module.exports = Object.freeze({
  STALE_TIME: 0,
  TIME_OUT_REQUEST: 1000 * 60 * 1,
  MODAL_BODY_TYPES: {
    USER_DETAIL: "USER_DETAIL",
    LEAD_ADD_NEW: "LEAD_ADD_NEW",
    CONFIRMATION: "CONFIRMATION",
    STORE_DISP_INDEX: "STORE_DISP_INDEX",
    PERMISSION_EDIT: "PERMISSION_EDIT",
    CUSTOMER_GROUP_EDIT: "CUSTOMER_GROUP_EDIT",
    AUTHORITY_ITEM_EDIT: "AUTHORITY_ITEM_EDIT",
    // DEPARTMENT_ADD: "DEPARTMENT_ADD",
    // DEPARTMENT_EDIT: "DEPARTMENT_EDIT",
    // CUSTOMER_EDIT: "CUSTOMER_EDIT",
    MESSAGE: "MESSAGE",
    SELECT_EMPLOYEE: "SELECT_EMPLOYEE",
    SELECT_CUSTOMER: "SELECT_CUSTOMER",
    SELECT_CUSTOMER_EMPLOYEE: "SELECT_CUSTOMER_EMPLOYEE",
    SELECT_SEKO_CUSTOMER_EMPLOYEE: "SELECT_SEKO_CUSTOMER_EMPLOYEE",
    SELECT_BUKKEN: "SELECT_BUKKEN",
    SELECT_CSV_BUKKEN: "SELECT_CSV_BUKKEN",
    SELECT_CONST: "SELECT_CONST",
    SELECT_LOGIN_USER: "SELECT_LOGIN_USER",
    LOGIN_USER_ADD: "LOGIN_USER_ADD",
    EMPLOYEE_SIMPLE_ADD: "EMPLOYEE_SIMPLE_ADD",
    CUSTOMER_EMPLOYEE_SIMPLE_ADD: "CUSTOMER_EMPLOYEE_SIMPLE_ADD",
    SELECT_CERTIFICATION_MST: "SELECT_CERTIFICATION_MST",
    ERROR: "ERROR",
    TEXT: "TEXT",
    DEPARTMENT_ADD: "DEPARTMENT_ADD",
    DEPARTMENT_MOVE: "DEPARTMENT_MOVE",
    WARNING: "WARNING", // 警告ダイアログ
    DEPARTMENT_SELECT: "DEPARTMENT_SELECT",
    DEPARTMENT_SELECT_TREE: "DEPARTMENT_SELECT_TREE",
    ANDES_BACKUP_LOCK: "ANDES_BACKUP_LOCK",
    ANDES_BACKUP_EDIT: "ANDES_BACKUP_EDIT",
    ANDES_BACKUP_DELETE: "ANDES_BACKUP_DELETE",
    // 日報
    DAIRY_REPORT_TEMPLATE_ITEM_ADD: "DAIRY_REPORT_TEMPLATE_ITEM_ADD",
    DAIRY_REPORT_LIST_ITEMS_OPTION_ADD: "DAIRY_REPORT_LIST_ITEMS_OPTION_ADD",
    DAIRY_REPORT_LIST_ITEMS_ADD: "DAIRY_REPORT_LIST_ITEMS_ADD",
    DAIRY_REPORT_LIST_ITEMS_OPTION_EDIT: "DAIRY_REPORT_LIST_ITEMS_OPTION_EDIT",
    DAIRY_REPORT_INFO: "DAIRY_REPORT_INFO",
    DAIRY_REPORT_OVER_ITEM: "DAIRY_REPORT_OVER_ITEM",
    DAIRY_REPORT_INFO_CANCEL_DELETE: "DAIRY_REPORT_INFO_CANCEL_DELETE",
    DAIRY_REPORT_OUTPUT: "DAIRY_REPORT_OUTPUT",

    ATTENDANCE_MESSAGE: "ATTENDANCE_MESSAGE",
    ATTENDANCE_HOLIDAY: "ATTENDANCE_HOLIDAY",
    LOCAL_CONFIG_ADD: "LOCAL_CONFIG_ADD", // 対象地域追加ダイアログ
    LOCAL_CONFIG_UPINFO: "LOCAL_CONFIG_UPINFO", // 地域設定更新情報ダイアログ
    LOCAL_CONFIG_ATFINFO: "LOCAL_CONFIG_ATFINFO", // 地域設定書式情報ダイアログ
    LOCAL_CONFIG_LOCATION_ADD: "LOCAL_CONFIG_LOCATION_ADD", //地域追加ダイアログ
    LOCAL_CONFIG_LOCATION_EDIT: "LOCAL_CONFIG_LOCATION_EDIT", //地域編集ダイアログ
    LOCAL_CONFIG_LOCATION_HISTORY: "LOCAL_CONFIG_LOCATION_HISTORY", // 地域設定更新履歴ダイアログ
    LOCAL_CONFIG_DELIVERYCONTROL: "LOCAL_CONFIG_DELIVERYCONTROL", //　地域設定配信開始・停止ダイアログ
    LOCAL_CONFIG_COMMENT_EDIT: "LOCAL_CONFIG_COMMENT_EDIT", //　地域設定コメント編集
    LOCAL_CONFIG_FILE_EDIT: "LOCAL_CONFIG_FILE_EDIT", //　地域設定ファイル編集
    LOCAL_CONFIG_FOLDER_EDIT: "LOCAL_CONFIG_FOLDER_EDIT", //　地域設定フォルダ編集
    LOCAL_CONFIG_OPERATION_LOG: "LOCAL_CONFIG_OPERATION_LOG", // 会社設定変更履歴ダイアログ
    BUKKEN_SETUP_ROOM: "BUKKEN_SETUP_ROOM",
    BUKKEN_SETUP_ROOM_DETAIL: "BUKKEN_SETUP_ROOM_DETAIL",
    BUKKEN_RELATED: "BUKKEN_RELATED",
    BUKKEN_JOIN_MEMBER: "BUKKEN_JOIN_MEMBER",
    BUKKEN_FILE: "BUKKEN_FILE",
    BUKKEN_DEPARTMENT: "BUKKEN_DEPARTMENT",
    CONSTRUCT_DEPARTMENT: "CONSTRUCT_DEPARTMENT",
    CONSTRUCT_MANAGER: "CONSTRUCT_MANAGER",
    SALES_DEPARTMENT: "SALES_DEPARTMENT",
    SALES_MANAGER: "SALES_MANAGER",
    BUKKEN_CUSTOMER: "BUKKEN_CUSTOMER",
    BUKKEN_EMPLOYEE: "BUKKEN_EMPLOYEE",
    BUKKEN_SEKO_EMPLOYEE: "BUKKEN_SEKO_EMPLOYEE",
    BUKKEN_CUSTOMER_EMPLOYEE: "BUKKEN_CUSTOMER_EMPLOYEE",
    BUKKEN_SEKO_CUSTOMER_EMPLOYEE: "BUKKEN_SEKO_CUSTOMER_EMPLOYEE",
    BUKKEN_CONST_MASTER: "BUKKEN_CONST_MASTER",
    BUKKEN_DELETE_DETAIL: "BUKKEN_DELETE_DETAIL",
    BUKKEN_EDIT_IMAGE_NAME: "BUKKEN_EDIT_IMAGE_NAME",
    BUKKEN_MANAGE_FOLDER_IMAGE: "BUKKEN_MANAGE_FOLDER_IMAGE",
    BUKKEN_STRUCTURE_FOLDER: "BUKKEN_STRUCTURE_FOLDER",
    BUKKEN_MANAGE_MASTER: "BUKKEN_MANAGE_MASTER",
    BUKKEN_ITEM_MASTER: "BUKKEN_ITEM_MASTER",
    BUKKEN_IMAGE_FOLDER_MASTER: "BUKKEN_IMAGE_FOLDER_MASTER",
    BUKKEN_ADD_PATTERN_NAME: "BUKKEN_ADD_PATTERN_NAME",
    BUKKEN_DELETE_FOLDER: "BUKKEN_DELETE_FOLDER",
    BUKKEN_DELETE_MASTER: "BUKKEN_DELETE_MASTER",
    BUKKEN_COMFIRM_MASTER: "BUKKEN_COMFIRM_MASTER",
    BUKKEN_DELETE_PATTER_NAME: "BUKKEN_DELETE_PATTER_NAME",
    JOIN_MEMBER_ADVANCED: "JOIN_MEMBER_ADVANCED",
    CUSTOMER_ADVANCED: "CUSTOMER_ADVANCED",
    MULTI_SELECT: "MULTI_SELECT",
    SEARCH_STATUS: "SEARCH_STATUS",
    TOTAL_DETAIL: "TOTAL_DETAIL",
    INFO_DETAIL: "INFO_DETAIL",
    REFERENCE_INFO: "REFERENCE_INFO",
    MUlTi_FILES: "MULTI_FILES",
    BUKKEN_FOLDER_SELECT: "BUKKEN_FOLDER_SELECT",
    BUKKEN_FOLDER_FILE_MOVE: "BUKKEN_FOLDER_FILE_MOVE",
    UPLOAD_FILE: "UPLOAD_FILE",
    LABORER_EMPLOYEE: "LABORER_EMPLOYEE",
    LABORER_CUSTOMER: "LABORER_CUSTOMER",
    BUKKEN_EMPLOYEE_LIST: "BUKKEN_EMPLOYEE_LIST",

    //共有ストレージ
    STORAGE_FOLDER_FILE_MOVE: "STORAGE_FOLDER_FILE_MOVE",

    //QUOTATION_MODAL
    EXPORT_QUOTATION: "EXPORT_QUOTATION",
    EXPORT_INVOICE: "EXPORT_INVOICE",
    CREATE_INVOICE: "CREATE_INVOICE",
    CUSTOMER_SEARCH_EMPLOYEE: "CUSTOMER_SEARCH_EMPLOYEE",
    JOIN_MEMBER_SEARCH: "JOIN_MEMBER_SEARCH",
    DELETE_QUOTATION_LIST: "DELETE_QUOTATION_LIST",
    DELETE_INVOICE_LIST: "DELETE_INVOICE_LIST",
    CONFIRM_REDIRECT_BUKKEN: "CONFIRM_REDIRECT_BUKKEN",
    CSV_IMPORT: "CSV_IMPORT",
    MAILBOX_CONFIRM_QUOTATION: "MAILBOX_CONFIRM_QUOTATION",
    MAILBOX_CONFIRM_INVOICE: "MAILBOX_CONFIRM_INVOICE",
    CONFIRM_REDIRECT_INVOICE: "CONFIRM_REDIRECT_INVOICE",
    ACCOUNT_NUMBER_SELECT: "ACCOUNT_NUMBER_SELECT",
    DELETE_DATA_ITEM_CSV: "DELETE_DATA_ITEM_CSV",
    QUOTATION_STATUS: "QUOTATION_STATUS",
    DELETE_PAYMENT_INVOICE: "DELETE_PAYMENT_INVOICE",
    MANAGE_PAYMENT_INVOICE: "MANAGE_PAYMENT_INVOICE",

    // NewsManage_Modal
    NEWS_TARGET_SELECT: "NEWS_TARGET_SELECT",
    CSV_READ: "CSV_READ",

    //SHASHIN_MODAL
    DELETE_PHOTOTBOOK: "DELETE_PHOTOTBOOK",
    DELETE_COMMENT: "DELETE_COMMENT",
    MANAGER_NAME: "MANAGER_NAME",

    /* DOCUMENT_REPOSITORY */
    SETTING_CATEGORY_BULLETIN: "SETTING_CATEGORY_BULLETIN",
    EDIT_CATEGORY_BULLETIN: "EDIT_CATEGORY_BULLETIN",
    CREATE_CATEGORY_BULLETIN: "CREATE_CATEGORY_BULLETIN",
    DELETE_CATEGORY_BULLETIN: "DELETE_CATEGORY_BULLETIN",
    USERS_READ_MODAL_BULLETIN: "USERS_READ_MODAL_BULLETIN",
    CATEGORY_DOCUMENT: "CATEGORY_DOCUMENT",
    DELETE_DOCUMENT: "DELETE_DOCUMENT",
    SETTING_CATEGORY_DOCUMENT: "SETTING_CATEGORY_DOCUMENT",

    DELETE_POST_BULLETIN: "DELETE_POST_BULLETIN",

    EDIT_CATEGORY_DOCUMENT: "EDIT_CATEGORY_DOCUMENT",
    DELETE_CATEGORY_DOCUMENT: "DELETE_CATEGORY_DOCUMENT",

    BUKKEN_SEARCH_FILE_MANAGEMENT: "BUKKEN_SEARCH_FILE_MANAGEMENT",

    CUSTOMER_EMPLOYEE_REGISTER: "CUSTOMER_EMPLOYEE_REGISTER",
    CUSTOMER_REGISTER: "CUSTOMER_REGISTER",
    EMPLOYEE_REGISTER: "EMPLOYEE_REGISTER",
    CUSTOMER_SELECT_EMPLOYEE: "CUSTOMER_SELECT_EMPLOYEE",

    SELECT_COMPANY: "SELECT_COMPANY",

    BLACKBOARD_CANDIDATE: "BLACKBOARD_CANDIDATE",
    BLACKBOARD_CANDIDATE_MANAGE: "BLACKBOARD_CANDIDATE_MANAGE",
    BLACKBOARD_CANDIDATE_DELETE: "BLACKBOARD_CANDIDATE_DELETE",
    BLACKBOARD_FOLDER: "BLACKBOARD_FOLDER",
    BLACKBOARD_DELETE: "BLACKBOARD_DELETE",

    DEPARTMENT_SETTING_REGISTER: "DEPARTMENT_SETTING_REGISTER",
    EMPLOYEE_SETTING_REGISTER: "EMPLOYEE_SETTING_REGISTER",
    CATEGORY_SELECTION: "CATEGORY_SELECTION",
    TIME_LINE_SETTING: "TIME_LINE_SETTING",
    SELECT_MULTI_EMPLOYEE: "SELECT_MULTI_EMPLOYEE",
    BUKKEN_SETTING_SEARCH: "BUKKEN_SETTING_SEARCH",
    PREVIEW_UPLOAD: "PREVIEW_UPLOAD",
    BUKKEN_AUTHORITY_DISPLAY_SETTING: "BUKKEN_AUTHORITY_DISPLAY_SETTING", // 参加者権限 表示権限設定
    BUKKEN_AUTHORITY_PARTICIPANT_EDIT: "BUKKEN_AUTHORITY_PARTICIPANT_EDIT", // 参加者権限 個別権限設定
    BUKKEN_FILE_PERMISSION_LIST: "BUKKEN_FILE_PERMISSION_LIST", // ファイル権限一覧
    BUKKEN_FOLDER_PERMISSION_LIST: "BUKKEN_FOLDER_PERMISSION_LIST", // フォルダ権限一覧
    BUKKEN_FILE_PERMISSION_SETTING: "BUKKEN_FILE_PERMISSION_SETTING", // ファイル権限設定
    BUKKEN_FOLDER_PERMISSION_SETTING: "BUKKEN_FOLDER_PERMISSION_SETTING", // フォルダ権限設定
    BUKKEN_MEMBER_SELECT: "BUKKEN_MEMBER_SELECT", // 参加者選択
    BUKKEN_JOIN_MEMBER_OPTION: "BUKKEN_JOIN_MEMBER_OPTION",
    EMPLOYEE_CREDENTIAL: "EMPLOYEE_CREDENTIAL",
    BUKKEN_CLASS: "BUKKEN_CLASS",
    BUKKEN_LOCATION: "BUKKEN_LOCATION",
    BUKKEN_CONTRACT: "BUKKEN_CONTRACT",
    MUTATE_WORKER_SCHEDULE: "MUTATE_WORKER_SCHEDULE",
    MUTATE_WORKERS_SCHEDULE: "MUTATE_WORKERS_SCHEDULE",
    DETAIL_SCHEDULE: "DETAIL_SCHEDULE",
    MUTATE_PROJECT_SCHEDULE: "MUTATE_PROJECT_SCHEDULE",
    MUTATE_PROJECTS_SCHEDULE: "MUTATE_PROJECTS_SCHEDULE",

    SETTING_START_DAY_OF_WEEK: "SETTING_START_DAY_OF_WEEK",
    SETTING_TIME_ALL_DAY: "SETTING_TIME_ALL_DAY",
    LABORER_REGISTER: "LABORER_REGISTER",
    BUKKEN_DISP_ITEM_MENU: "BUKKEN_DISP_ITEM_MENU",

    COMPANY_CONTACT_FORM: "COMPANY_CONTACT_FORM",
    DEFAULT: ""
  },

  APP_TYPES: {
    BUKKEN_APP: "BUKKEN_APP"
  },

  RIGHT_DRAWER_TYPES: {
    NOTIFICATION: "NOTIFICATION",
    CALENDAR_EVENTS: "CALENDAR_EVENTS"
  },

  CONFIRMATION_MODAL_CLOSE_TYPES: {
    LEAD_DELETE: "LEAD_DELETE"
  },

  BASE_LIST: [
    { key: 1, value: "岡山支店" },
    { key: 2, value: "東京支店" },
    { key: 3, value: "大阪支店" },
    { key: 4, value: "福岡営業所" },
    { key: 5, value: "仙台営業所" },
    { key: 6, value: "名古屋営業所" },
    { key: 7, value: "営業企画部" },
    { key: 8, value: "東日本サポートセンター" },
    { key: 9, value: "西日本サポートセンター" },
    { key: 10, value: "新規事業部" }
  ],

  CATEGORY_LIST: [
    { value: 1, label: "工事管理" },
    { value: 2, label: "CADサービス" }
  ],

  COMPANY_AUTHORITY: [
    { labelTitle: "企業作成", value: 1, checked: true },
    { labelTitle: "企業編集", value: 2, checked: true },
    { labelTitle: "企業論理削除", value: 4, checked: true },
    { labelTitle: "企業論理削除復帰", value: 8, checked: true },
    { labelTitle: "企業完全削除", value: 16, checked: true },
    { labelTitle: "企業検索", value: 32, checked: true },
    { labelTitle: "企業情報取得", value: 64, checked: true }
  ],

  CONFIG_AUTHORITY: [
    { labelTitle: "ストレージ容量変更", value: 1, checked: true },
    { labelTitle: "版数管理変更", value: 2, checked: true },
    { labelTitle: "バックアップ変更", value: 4, checked: true },
    { labelTitle: "設定取得", value: 8, checked: true }
  ],

  USER_INFO_AUTHORITY: [{ labelTitle: "システム情報一覧取得", value: 1, checked: true }],

  SYSTEM_COMPANY_UUID: {
    SYSTEM_COMPANY_UUID: "00000000-0000-0000-0000-000000000000"
  },

  QUERY_KEY: {
    RELATED_PROPERTY: "RELATED_PROPERTY",
    LOCATION_MST: "LOCATION_MST",
    CONTRACT_CLASS: "CONTRACT_CLASS",
    PROPERTY_CLASSTION: "PROPERTY_CLASSTION",
    BUKKEN_DETAIL: "BUKKEN_DETAIL",
    BUKKEN_SEARCH: "BUKKEN_SEARCH",
    BUKKEN_SEARCH_ADVANCED: "BUKKEN_SEARCH_ADVANCED",
    BUKKEN_MEMBER_SEARCH: "BUKKEN_MEMBER_SEARCH",
    BUKKEN_SEARCH_INFO: "BUKKEN_SEARCH_INFO",
    BUKKEN_ITEM_SEARCH: "BUKKEN_ITEM_SEARCH",
    BUKKEN_ITEM_MST_SEARCH: "BUKKEN_ITEM_MST_SEARCH",
    BUKKEN_DETAIL_ADVANCED: "BUKKEN_DETAIL_ADVANCED",
    GET_ALL_FOLDER_BUKKEN: "GET_ALL_FOLDER_BUKKEN",
    GET_FOLDER_CHILDREN: "GET_FOLDER_CHILDREN",
    DOWNLOAD_FILE: "DOWNLOAD_FILE",
    DOWNLOAD_FOLDER: "DOWNLOAD_FOLDER",
    DELETE_FILE: "DELETE_FILE",
    DELETE_FOLDER: "DELETE_FOLDER",
    DOWNLOAD_MULTI_FILES: "DOWNLOAD_MULTI_FILES",
    REGISTER_FOLDER: "REGISTER_FOLDER",
    REGISTER_FILE: "REGISTER_FILE",
    CREATE_FILE: "CREATE_FILE",
    CREATE_PHOTO: "CREATE_PHOTO",
    CHK_TAMPERING: "CHK_TAMPERING",
    CHANGE_FOLDER_NAME: "CHANGE_FOLDER_NAME",
    CHANGE_FILE_NAME: "CHANGE_FILE_NAME",
    REGISTER_IMAGE_FOLDER: "REGISTER_IMAGE_FOLDER",
    CHANGE_IMAGE_FOLDER_NAME: "CHANGE_IMAGE_FOLDER_NAME",
    GET_BUKKEN_RELATED_INFO: "GET_BUKKEN_RELATED_INFO",
    DELETE_PHOTO_BUKKEN_FOLDER: "DELETE_PHOTO_BUKKEN_FOLDER",
    CONST_MST_ALL: "CONST_MST_ALL",
    GET_INFO_FILE: "GET_INFO_FILE",
    DELETE_BUKKEN_FILE: "DELETE_BUKKEN_FILE",
    DELETE_BUKKEN_FOLDER: "DELETE_BUKKEN_FOLDER",
    DELETE_BUKKEN_PHOTO: "DELETE_BUKKEN_PHOTO",
    DELETE_MST_FILE: "DELETE_MST_FILE",
    DELETE_MST_FOLDER: "DELETE_MST_FOLDER",
    GET_THUMBNAILS: "GET_THUMBNAILS",
    GET_MAX_SIZE_UPLOAD_FILE: "GET_MAX_SIZE_UPLOAD_FILE",
    SEARCH_FOLDER_FILE: "SEARCH_FOLDER_FILE",
    BUKKEN_FILTER_SETTING_SEARCH: "BUKKEN_FILTER_SETTING_SEARCH",
    BUKKEN_FILTER_PATTERN: "BUKKEN_FILTER_PATTERN",

    GET_ALL_BUKKEN_CLASS_MST: "GET_ALL_BUKKEN_CLASS_MST",
    GET_BUKKEN_CLASS_MST_INFO: "GET_BUKKEN_CLASS_MST_INFO",
    CHANGE_BUKKEN_CLASS_MST: "CHANGE_BUKKEN_CLASS_MST",
    CREATE_BUKKEN_CLASS_MST: "CREATE_BUKKEN_CLASS_MST",
    DELETE_BUKKEN_CLASS_MST: "DELETE_BUKKEN_CLASS_MST",

    GET_ALL_BUKKEN_TAB_MST: "GET_ALL_BUKKEN_TAB_MST",
    GET_ALL_BUKKEN_TAB_MST_NEW: "GET_ALL_BUKKEN_TAB_MST_NEW",
    CHANGE_BUKKEN_TAB_MST: "CHANGE_BUKKEN_TAB_MST",
    CREATE_BUKKEN_TAB_MST: "CREATE_BUKKEN_TAB_MST",
    DELETE_BUKKEN_TAB_MST: "DELETE_BUKKEN_TAB_MST",
    EDIT_BUKKEN_TAB_LIST: "EDIT_BUKKEN_TAB_LIST",

    GET_ALL_LOCATION_MST: "GET_ALL_LOCATION_MST",
    CHANGE_LOCATION_MST: "CHANGE_LOCATION_MST",
    CREATE_LOCATION_MST: "CREATE_LOCATION_MST",
    DELETE_LOCATION_MST: "DELETE_LOCATION_MST",

    GET_ALL_CONST_TYPE_MST: "GET_ALL_CONST_TYPE_MST",
    CHANGE_CONST_TYPE_MST: "CHANGE_CONST_TYPE_MST",
    CREATE_CONST_TYPE_MST: "CREATE_CONST_TYPE_MST",
    DELETE_CONST_TYPE_MST: "DELETE_CONST_TYPE_MST",

    GET_ALL_TEMPLATE_MST: "GET_ALL_TEMPLATE_MST",
    CHANGE_TEMPLATE_MST: "CHANGE_TEMPLATE_MST",
    CREATE_TEMPLATE_MST: "CREATE_TEMPLATE_MST",
    DELETE_TEMPLATE_MST: "DELETE_TEMPLATE_MST",

    GET_ALL_BUKKEN_COMMON_FOLDER: "GET_ALL_BUKKEN_COMMON_FOLDER",

    DEPARTMENT_INFO: "DEPARTMENT_INFO",
    EMPLOYEE_SEARCH: "EMPLOYEE_SEARCH",
    CUSTOMER_SEARCH: "CUSTOMER_SEARCH",
    CUSTOMER_EMPLOYEE: "CUSTOMER_EMPLOYEE",
    CUSTOMER_GROUP: "CUSTOMER_GROUP",
    JOIN_MEMBER: "JOIN_MEMBER",

    GET_BUKKEN_PHOTO_FOLDERS_CHILDREN: "GET_BUKKEN_PHOTO_FOLDERS_CHILDREN",

    GET_COMPANY_INFO: "GET_COMPANY_INFO",

    GET_BULLETIN_POST_PORTAL: "GET_BULLETIN_POST_PORTAL",
    SAVE_SETTING_NEWS: "SAVE_SETTING_NEWS",
    GET_SETTING_NEWS: "GET_SETTING_NEWS",
    GET_SETTING_LIST_BUKKEN: "GET_SETTING_LIST_BUKKEN",
    SAVE_SETTING_LIST_BUKKEN: "SAVE_SETTING_LIST_BUKKEN",

    // mst_item_list query key
    // GET_ALL_BUKKEN_CLASS_MST: "GET_ALL_BUKKEN_CLASS_MST",
    GET_BUKKEN_ITEMLIST_MST_INFO: "GET_BUKKEN_ITEMLIST_MST_INFO",
    CHANGE_BUKKEN_ITEMLIST_MST: "CHANGE_BUKKEN_ITEMLIST_MST",
    CREATE_BUKKEN_ITEMLIST_MST: "CREATE_BUKKEN_ITEMLIST_MST",
    DELETE_BUKKEN_ITEMLIST_MST: "DELETE_BUKKEN_ITEMLIST_MST",

    //QUOTATION
    GET_QUOTATION_MST: "GET_QUOTATION_MST",
    GET_QUOTATION_ITEM_LIST: "GET_QUOTATION_ITEM_LIST",
    GET_QUOTATION_DETAIL: "GET_QUOTATION_DETAIL",
    QUOTATION_LIST: "QUOTATION_LIST",
    QUOTATION_LAST_INPUT: "QUOTATION_LAST_INPUT",
    QUOTATION_CREATE: "QUOTATION_CREATE",
    QUOTATION_EDIT: "QUOTATION_EDIT",
    QUOTATION_ITEM_CREATE: "QUOTATION_ITEM_CREATE,",
    QUOTATION_ITEM_DELETE: "QUOTATION_ITEM_DELETE",
    QUOTATION_ITEM_EDIT: "QUOTATION_ITEM_EDIT",
    IMPORT_ITEM: "IMPORT_ITEM",
    QUOTATION_SEARCH_ADVANCED: "QUOTATION_SEARCH_ADVANCED",
    DOWNLOAD_QUOTATION: "DOWNLOAD_QUOTATION",
    GET_LAST_SETTING_QUOTATION: "GET_LAST_SETTING_QUOTATION",
    GET_LAST_POSITION_QUOTATION: "GET_LAST_POSITION_QUOTATION",

    //INVOICE
    GET_INVOICE_LIST: "GET_INVOICE_LIST",
    GET_INVOICE_MST: "GET_INVOICE_MST",
    GET_INVOICE_LAST_INPUT: "GET_INVOICE_LAST_INPUT",
    GET_INVOICE_DETAIL: "GET_INVOICE_DETAIL",
    INVOICE_CREATE: "INVOICE_CREATE",
    DOWNLOAD_INVOICE: "DOWNLOAD_INVOICE",

    // SHASHI KANRI
    CHECK_PHOTO: "CHECK_PHOTO",
    GET_PHOTOBOOK: "GET_PHOTOBOOK",
    PHOTOBOOK_LIST_BY_BUKKEN: "PHOTOBOOK_LIST_BY_BUKKEN",
    GET_TEMPLATE_PHOTOBOOK: "GET_TEMPLATE_PHOTOBOOK",
    GET_PHOTOS_IN_MONTH: "GET_PHOTOS_IN_MONTH",
    GET_PHOTO_NOTE: "GET_PHOTO_NOTE",
    GET_LIST_TEMPLATE_PHOTOBOOK: "GET_LIST_TEMPLATE_PHOTOBOOK",
    GET_THUMBNAIL_HIGHT_QUALITY: "GET_THUMBNAIL_HIGHT_QUALITY",
    INVOICE_SEARCH_ADVANCED: "INVOICE_SEARCH_ADVANCED",
    GET_EMPLOYEE_FROM_USER: "GET_EMPLOYEE_FROM_USER",
    GET_LAST_SETTING_INVOICE: "GET_LAST_SETTING_INVOICE",
    GET_LAST_POSITION_INVOICE: "GET_LAST_POSITION_INVOICE",
    //SHARED STORAGE
    GET_SYNC_FOLDER_CHILDREN: "GET_SYNC_FOLDER_CHILDREN",
    GET_SYNC_PERMISSION: "GET_SYNC_PERMISSION",

    // ユーザー管理者
    // - 資格管理
    CREATE_CERTIFICATION_MST: "CREATE_CERTIFICATION_MST",
    GET_CERTIFICATION_MST: "GET_CERTIFICATION_MST",
    EDIT_CERTIFICATION_MST: "EDIT_CERTIFICATION_MST",
    SEARCH_CERTIFICATION_MST: "SEARCH_CERTIFICATION_MST",
    DELETE_CERTIFICATION_MST: "DELETE_CERTIFICATION_MST",
    RECOVER_CERTIFICATION_MST: "RECOVER_CERTIFICATION_MST",

    SEARCH_SYSTEM_CERTIFICATION_MST: "SEARCH_SYSTEM_CERTIFICATION_MST",

    // - 社員資格管理
    CREATE_EMPLOYEE_CERTIFICATION: "CREATE_EMPLOYEE_CERTIFICATION",
    GET_EMPLOYEE_CERTIFICATION: "GET_EMPLOYEE_CERTIFICATION",
    EDIT_EMPLOYEE_CERTIFICATION: "EDIT_EMPLOYEE_CERTIFICATION",
    SEARCH_EMPLOYEE_CERTIFICATION: "SEARCH_EMPLOYEE_CERTIFICATION",
    DELETE_EMPLOYEE_CERTIFICATION: "DELETE_EMPLOYEE_CERTIFICATION",
    RECOVER_EMPLOYEE_CERTIFICATION: "RECOVER_EMPLOYEE_CERTIFICATION",
    // - 得意先社員資格管理
    CREATE_CUSTOMER_EMPLOYEE_CERTIFICATION: "CREATE_CUSTOMER_EMPLOYEE_CERTIFICATION",
    GET_CUSTOMER_EMPLOYEE_CERTIFICATION: "GET_CUSTOMER_EMPLOYEE_CERTIFICATION",
    EDIT_CUSTOMER_EMPLOYEE_CERTIFICATION: "EDIT_CUSTOMER_EMPLOYEE_CERTIFICATION",
    SEARCH_CUSTOMER_EMPLOYEE_CERTIFICATION: "SEARCH_CUSTOMER_EMPLOYEE_CERTIFICATION",
    DELETE_CUSTOMER_EMPLOYEE_CERTIFICATION: "DELETE_CUSTOMER_EMPLOYEE_CERTIFICATION",
    RECOVER_CUSTOMER_EMPLOYEE_CERTIFICATION: "RECOVER_CUSTOMER_EMPLOYEE_CERTIFICATION",

    // 環境変数
    GET_COMPANY_ENV: "GET_COMPANY_ENV",
    CREATE_ENV_INFO: "CREATE_ENV_INFO",
    CREATE_MULTI_ENV_INFO: "CREATE_MULTI_ENV_INFO",
    GET_AUTONUM_CONF: "GET_AUTONUM_CONF",
    GET_PORTAL_CONTENT_ORDER: "GET_PORTAL_CONTENT_ORDER",

    // FILE S3 UPLOAD
    STEP_CREATE_FILE: "STEP_CREATE_FILE",
    STEP_UPDATE_FILE: "STEP_UPDATE_FILE",
    STEP_UPDATE_CONTENT_FILE: "STEP_UPDATE_CONTENT_FILE",
    STEP_UPDATE_PHOTO: "STEP_UPDATE_PHOTO",
    // 匠PAD関連
    POST_ORG_FILE: "POST_ORG_FILE",

    // Admin Dashboard
    COMPANIES_CONTRACT_COUNT: "COMPANIES_CONTRACT_COUNT",

    // BLACK-BOARD
    BUKKEN_BLACKBOARD_MST: "BUKKEN_BLACKBOARD_MST",
    BUKKEN_BLACKBOARD_LIST: "BUKKEN_BLACKBOARD_LIST",
    BUKKEN_BLACKBOARD_PHOTO_LIST: "BUKKEN_BLACKBOARD_PHOTO_LIST",
    BUKKEN_BLACKBOARD_EDIT: "BUKKEN_BLACKBOARD_EDIT",

    BUKKEN_WHITEBOARD_LIST: "BUKKEN_WHITEBOARD_LIST",
    WHITEBOARD_VIEW: "WHITEBOARD_VIEW",
    WHITEBOARD_ASSIGNMENT_INFO: "WHITEBOARD_ASSIGNMENT_INFO",
    WHITEBOARD_EMPLOYEE_SEARCH: "WHITEBOARD_EMPLOYEE_SEARCH",
    WHITEBOARD_CUSTOMER_EMPLOYEE_SEARCH: "WHITEBOARD_CUSTOMER_EMPLOYEE_SEARCH",
    SEARCH_COMPANY_NEWS: "SEARCH_COMPANY_NEWS",

    // 契約連絡者
    COMPANY_CONTACT_SEARCH: "COMPANY_CONTACT_SEARCH",
    COMPANY_CONTACT_CREATE: "COMPANY_CONTACT_CREATE",
    COMPANY_CONTACT_EDIT: "COMPANY_CONTACT_EDIT",
    COMPANY_CONTACT_DELETE: "COMPANY_CONTACT_DELETE",
    COMPANY_CONTACT_GET: "COMPANY_CONTACT_GET",
  },
  ITEM_TYPE: {
    BLANK: -1, // 空白
    INPUT: 0, // 文字
    DATE: 1, // 日付
    SELECT: 2, // セレクトボックス
    RADIO_BUTTON: 3, // ラジオボタン
    CHECKBOX: 4, // チェックボックス
    EMPLOYEE: 5, // 社員
    DEPARTMENT: 6, // 部署
    CUSTOMER: 7, // 得意先
    CUSTOMER_EMPLOYEE: 8, // 得意先担当者
    CONST_MASTER: 9, // 工種
    CONTRACT_TYPE: 10, // 請負区分
    ROOM: 11, // 部屋
    STATUS: 12, // 進捗状況
    RELATED_BUKKEN: 13, // 関連物件
    JOIN_MEMBER: 14, // 参加者
    LABEL: 15, // ラベル
    PHONE: 16, // 電話番号
    QUALIFICATION: 17, // 資格情報
    ADDRESS: 18, // 住所
    SEKO_EMPLOYEE: 19, // (施工会社の)社員（自社と特定の会社を状況によって出す）
    SPAN_TYPE_LIST: [15, 18] //　一行使用する種類の一覧(ラベルと住所)
  },
  PREFIX: {
    JOIN_MEMBER_ADVANCED: "JOIN_MEMBER_ADVANCED"
  },
  BUKKEN_TAB_UUID: "00000000-0000-0000-0000-000000000000",
  USER_UUID: "00000000-0000-0000-0000-000000000000",
  PERSONAL_SETTING: 1,
  COMPANY_SETTING: 2,
  ITEM_TYPE_REMOVE: -1,

  // メーター番号(申請情報タブ)用
  METER_NUMBER_ITEM_CODE: "$meter_number",

  ARRAY_ITEM_CODE: ["1", "2", "3", "4", "5", "6", "7"],
  INVALID: -1,
  INVALID_FOR_IMCOMPLETE_DATA: -2,
  INVALID_FOR_IMCOMPLETE_DATE_DATA: -3,
  SETTING_VALIDATE: ["1", "2"],

  SORT_ORDER_DEFAULT: 9999,
  PROGRESS_CODITION: ["完了", "失注"],

  CONFIG_DEFAULT_WIDTH: {
    ITEM_CODE: {
      1: "300px",
      2: "250px",
      3: "150px",
      4: "250px",
      5: "250px",
      6: "100px",
      7: "200px"
    },
    ITEM_TYPE: {
      0: "150px",
      1: "130px",
      2: "150px",
      3: "150px",
      4: "200px",
      5: "150px",
      6: "150px",
      7: "200px",
      8: "150px",
      9: "100px",
      10: "100px",
      11: "100px",
      12: "100px",
      13: "150px"
    }
  },

  SEARCH_SCREEN: {
    BUKKEN_LIST: "BUKKEN_LIST",
    JOIN_MEMBER_MODAL: "JOIN_MEMBER_MODAL",
    JOIN_MEMBER_CUSTOMER_EMPLOYEE_MODAL: "JOIN_MEMBER_CUSTOMER_EMPLOYEE_MODAL",
    CUSTOMER_MODAL: "CUSTOMER_MODAL",
    CUSTOMER_EMPLOYEE_MODAL: "CUSTOMER_EMPLOYEE_MODAL"
  },

  CASE_PATTERN_SEARCH: "pattern_search",
  WARNING_CUSTOMER_UUID: "WARNING_CUSTOMER_UUID",
  WARNING_CUSTOMER_UUID_CONTRACT: "WARNING_CUSTOMER_UUID_CONTRACT",
  WARNING_CUSTOMER_UUID_EMPLOYEE: "WARNING_CUSTOMER_UUID_EMPLOYEE",

  TYPE_DATE: {
    MATCHING: "0",
    WITHIN_RANGE: "1",
    OUT_OF_RANGE: "2",
    BEFORE: "3",
    AFTER: "4"
  },

  BASIC_INFO_UUID_LIST: {
    "00000000000000000000000000000001": "progress",
    "00000000000000000000000000000002": "parent_bukken_uuid",
    "00000000000000000000000000000003": "bukken_num",
    "00000000000000000000000000000004": "bukken_name",
    "00000000000000000000000000000005": "zip_code",
    "00000000000000000000000000000006": "address",
    "00000000000000000000000000000007": "prefectures",
    "00000000000000000000000000000008": "municipality",
    "00000000000000000000000000000009": "district",
    "00000000000000000000000000000010": "town_village",
    "00000000000000000000000000000011": "house_number",
    "00000000000000000000000000000012": "building_name",
    "00000000000000000000000000000013": "site_name",
    "00000000000000000000000000000014": "bukken_class_uuid",
    "00000000000000000000000000000015": "location_uuid",
    "00000000000000000000000000000016": "contract_class",
    "00000000000000000000000000000017": "bukken_order_name",
    "00000000000000000000000000000018": "bukken_orderer_manager_name",
    "00000000000000000000000000000019": "bukken_construct_name",
    "00000000000000000000000000000020": "bukken_construct_manager_name",
    "00000000000000000000000000000021": "own_manager_uuid",
    "00000000000000000000000000000022": "department_uuid",
    "00000000000000000000000000000023": "bukken_member",
    "00000000000000000000000000000024": "construct_start_dt",
    "00000000000000000000000000000025": "construct_end_dt"
  },

  MIN_BUKKEN_NUM_LENGTH: 3,
  INITIAL_PROGRESS_CONDITION: ["受付", "現調", "見積", "内示", "受注", "申請", "着工", "竣工", "検査", "請求", "入金"],

  //QUOTATION_INVOICE
  MAX_BANK_ACCOUNTS: 5,
  BUKKEN_UUID_DEFAULT: "00000000-0000-0000-0000-000000000000",
  QUOTATION_STATUS_DRAFT: "00000000-0000-0000-0000-000000000001",
  QUOTATION_STATUS_REGISTER: "00000000-0000-0000-0000-000000000005",
  TAB_ACTIVE_QUOTATION: "TAB_QUOTATION",
  TAB_ACTIVE_INVOICE: "TAB_INVOICE",
  TABLE_COLOR_QUOTATION: {
    "00000000-0000-0000-0000-000000000001": "save_draft_quotation",
    "00000000-0000-0000-0000-000000000005": "created_quotation",
    "00000000-0000-0000-0000-000000000010": "sent_quotation",
    "00000000-0000-0000-0000-000000000015": "cancelled_quotation",
    "00000000-0000-0000-0000-000000000020": "order_received_quotation",
    "00000000-0000-0000-0000-000000000090": "lost_order_quotation"
  },

  //INVOICE
  INVOICE_TABLE_COLOR: {
    "00000000-0000-0000-0000-000000000001": "save_draft_invoice",
    "00000000-0000-0000-0000-000000000005": "unclaimed_invoice",
    "00000000-0000-0000-0000-000000000010": "sent_invoice",
    "00000000-0000-0000-0000-000000000015": "partially_deposited_invoice",
    "00000000-0000-0000-0000-000000000020": "payment_completed_invoice",
    "00000000-0000-0000-0000-000000000090": "discarded_invoice"
  },
  TAX_KIND_UUID: [
    "00000000-0000-0000-0000-000000000001", //10%
    "00000000-0000-0000-0000-000000000010" //軽減8%
  ],
  TAX_SHOW_UUID: [
    "00000000-0000-0000-0000-000000000001", //税別表示
    "00000000-0000-0000-0000-000000000005", //税込表示
    "00000000-0000-0000-0000-000000000010" //税込表示(免税)
  ],

  TAX_FRACTION_UUID: [
    "00000000-0000-0000-0000-000000000001", //切り捨て
    "00000000-0000-0000-0000-000000000005", //切り上げ
    "00000000-0000-0000-0000-000000000010" //四捨五入
  ],

  TYPE_INPUT_TAX: {
    INPUT_NORMAL: 1,
    INPUT_COMMENT: 3,
    INPUT_DISCOUNT: 5
  },
  ITEM_NAME_DISCOUNT_DEFAULT: "値引き",
  ALL_TAX_UUID: "00000000-0000-0000-0000-000000000011", // discount all

  WITHHOLDING_TAX_UUID: [
    "00000000-0000-0000-0000-000000000001", //なし
    "00000000-0000-0000-0000-000000000005", //あり (復興税あり)
    "00000000-0000-0000-0000-000000000010" //あり (復興税なし)
  ],
  SHOW_BUTTON_EDIT: "00000000-0000-0000-0000-000000000005",

  DEFAULT_STATUS_UUIDS: {
    quotation: [
      "00000000-0000-0000-0000-000000000001",
      "00000000-0000-0000-0000-000000000005",
      "00000000-0000-0000-0000-000000000010"
    ],
    invoice: [
      "00000000-0000-0000-0000-000000000001",
      "00000000-0000-0000-0000-000000000005",
      "00000000-0000-0000-0000-000000000010",
      "00000000-0000-0000-0000-000000000020"
    ]
  },
  OUOTATION_EXPORT_UUIDS: [
    "00000000-0000-0000-0000-000000000005",
    "00000000-0000-0000-0000-000000000010",
    "00000000-0000-0000-0000-000000000015"
  ],
  INVOICE_EXPORT_UUIDS: [
    "00000000-0000-0000-0000-000000000005",
    "00000000-0000-0000-0000-000000000010",
    "00000000-0000-0000-0000-000000000015",
    "00000000-0000-0000-0000-000000000020",
    "00000000-0000-0000-0000-000000000090"
  ],

  OPTION_SELECTBOX_LIMIT_DATE_INVOICE: ["翌月末", "翌々月末", "任意"],
  LIMIT_DT_SELECTION: [
    1, //翌月末
    10, //翌々月末
    100 //任意
  ],
  QUOTATION_FLG_DISPLAY: 0,
  QUOTATION_FLG_UN_DISPLAY: 1,
  STATUS_CODE_DO_NOT_PERMISSION: "210",
  TITLE_CSV_TABLE: ["品名", "規格・型番", "単位", "単価", "原価", "税区分"],
  TITLE_CSV_IMPORT_DATA: ["品名", "規格・型番", "数量", "単位", "単価", "原価", "税区分"],
  // CHARACTER_REGEX_FOLDER_NAME: /[\/\\:*?"<>|,;]/
  CHARACTER_REGEX_FILE_NAME: /[\/\\:*?"<>|]/,
  CHARACTER_REGEX_FOLDER_NAME: /[\/\\:*?"<>|]/,

  ALL_SYSTEM_UUID: "00000000-0000-0000-0000-000000000000", // KH: 00000000-0000-0000-0000-000000000000

  SHARE_STORAGE_FOLDER_UUID: "00000000-0000-0000-0000-000000000301",

  SHARE_STORAGE_FOLDER_UUID: "00000000-0000-0000-0000-000000000301",

  SHARE_STORAGE_FOLDER_UUID: "00000000-0000-0000-0000-000000000301",

  //SHASHI KANRI
  COLOR_WEEKEND: {
    SATURDAY: "text-blue-500",
    SUNDAY: "text-[#FF0000]"
  },
  EXPORT_FILE_TYPE: {
    PDF: 0,
    EXCEL: 1
  },
  DEBOUNCE_TIME: 400,
  PERMISSION_SHARED_STORAGE: {
    NOT_PERMISSION: 0,
    HAS_PERMISSION: 1
  },
  KEYS_ENV_UPLOAD: ["MAX_UPLOAD_SIZE"],
  KEYS_ENV_GET_SETTING_NEWS: ["NEW_BULLETIN_DAYS", "DATA_LIMIT_NUM"],
  ONE_MILLION: 1000000,
  LIMIT_QUOTATION_EXPIRATION_DT: 65535,
  ITEM_UNIT_PRICE_MAX_LENGTH: 10,
  MAX_SIZE_UPLOAD_FILE: 20, // 20MB,
  FIlE_TYPES: {
    IMAGE: ["jpg", "jpeg", "png", "gif", "bmp", "webp"],
    VIDEO: [".mp4", ".webm", ".ogg", ".mov"],
    PDF: ["pdf"],
    TEXT: ["txt", "log"],
    DOCUMENT: ["xlsx", "xls", "pptx", "xlsm", "ppt", "pptm"],
    WORD: ["doc", "docx", "docm"]
  },
  PREVIEW_SUPPORT: [
    "xlsx",
    "xls",
    "docx",
    "pptx",
    "doc",
    "docm",
    "xlsm",
    "ppt",
    "pptm",
    "pdf",
    "jpg",
    "jpeg",
    "png",
    "gif",
    "bmp",
    "webp"
  ],

  // Enum-like object mapping actions to their respective identifiers for S3 file operations
  VIEW_URL_S3: {
    GET_THUMBNAILS: 1, // Retrieve thumbnail images
    GET_CONTENT_FILE: 2, // Fetch the main content file
    GET_CONTENT_PDF_FILE: 3, // Fetch the main content PDF file
    DOWNLOAD_FILE: 102 // Download the file in its entirety
  },

  ROOT_CATEGORY_NAME: "ルート",

  // NEWS IN PORTAL
  DATA_LIMIT_NUM: [
    { key: 5, value: 5 },
    { key: 10, value: 10 },
    { key: 15, value: 15 },
    { key: 20, value: 20 },
    { key: 25, value: 25 },
    { key: 30, value: 30 }
  ], //ポータルの新着情報の表示件数

  // TYPE BUKKEN FOLDER SEARCH
  BUKKEN_FOLDER_SEARCH_TYPE: {
    FILE: "1",
    IMAGE: "2",
    DRAWING: "4",
    INSPECTION: "8"
  },

  // 並び替えの対象リスト
  ORDER_TYPES: [
    { code: "bukken_num", name: "物件番号" },
    { code: "bukken_name", name: "物件名" },
    { code: "address", name: "現場住所" }
  ],

  // 並び順の種類
  ORDER_SORTS: [
    { sort: 1, label: "降順" }, // 降順（大きい順、わ→あ）
    { sort: 0, label: "昇順" } // 昇順（小さい順、あ→わ）
  ],

  EXPORT_RECALL_TIME: 1000 * 5, // 5 seconds for recall time of export apis
  FILE_PROCESS_STATUS: {
    NOT_CREATED: 0, // 'Not Created'
    CREATING: 1, // 'Creating'
    CREATED: 2, // 'Created'
    FAILED: 3 // 'Failed'
  },

  MAX_UUID_CALLED_ONCE: 10, // Maximum number of UUIDs to fetch in a single call
  MAX_RECALL_FOLDER_TIMES: 12, // Maximum number of times to refetch folder data if it is still generating
  FOLDER_RECALL_TIME: 1000 * 5, // 5 seconds for recall time of folder data
  ATF_CHECK_STATUS_TIME: 1000 * 5, // 5 seconds for re-check ATF status
  UPLOAD_STATUS_RECALL_TIME: 1000 * 5,
  MAX_RECALL_DOCUMENT_BULLETIN_TIMES: 12, // 1 minutes for recall time of document bulletin
  DOCUMENT_BULLETIN_RECALL_TIME: 1000 * 5, // 5 seconds for recall time of document bulletin

  PHOTOBOOK_VERSION: {
    v1: 1,
    v2: 2
  },

  KEY_VIEW_MODE_MANAGE: {
    FILE: "FILE",
    IMAGE: "IMAGE",
    DRAWING: "DRAWING",
    INSPECTION: "INSPECTION",
    SHARE_STORAGE: "SHARESTORAGE"
  },

  KEY_VIEW_MODE_SP_MANAGE: {
    FILE: "FILE_SP",
    IMAGE: "IMAGE_SP",
    DRAWING: "DRAWING_SP",
    INSPECTION: "INSPECTION_SP"
  },

  VIEW_MODE_VALUE: {
    LISTVIEW: "1",
    GRIDVIEW: "0"
  },

  PORTAL_SECTION_CONTENT_TYPE: {
    ANDES_NEWS: "00000000-0000-0000-0000-000000000001", //ANDESニュース
    BULLETIN_NEWS: "00000000-0000-0000-0000-000000000002", //掲示板新着情報
    CAPACITY: "00000000-0000-0000-0000-000000000003", //使用容量
    BUKKENS: "00000000-0000-0000-0000-000000000004" //ピン留め物件
  },

  LIST_STATISTICS_APPS: {
    standard_apps: [
      {
        system_id: "bukken",
        system_uuid: "00000000-0000-0000-0000-000000000002",
        system_name: "物件管理"
      },
      {
        system_id: "andes-backup",
        system_uuid: "00000000-0000-0000-0000-000000000003",
        system_name: "ANDESバックアップ"
      },
      {
        system_id: "bulletin-manage",
        system_uuid: "00000000-1000-0000-0000-000000000011",
        system_name: "掲示板"
      },
      {
        system_id: "document-manage",
        system_uuid: "00000000-1000-0000-0000-000000000012",
        system_name: "文書庫"
      }
    ],
    option_apps: [
      {
        system_id: "dairy-report",
        system_uuid: "00000000-0000-0000-0000-000000010001",
        system_name: "日報"
      },
      {
        system_id: "attendance",
        system_uuid: "00000000-0000-0000-0000-000000010002",
        system_name: "勤怠"
      },
      {
        system_id: "quotation",
        system_uuid: "00000000-0000-0000-0000-000000010003",
        system_name: "見積"
      },
      {
        system_id: "invoice",
        system_uuid: "00000000-0000-0000-0000-000000010004",
        system_name: "請求"
      },
      {
        system_id: "takumipad",
        system_uuid: "00000000-0000-0000-0000-000000010005",
        system_name: "匠PAD"
      },
      {
        system_id: "photobook-manage",
        system_uuid: "00000000-1000-0000-0000-000000010006",
        system_name: "写真台帳"
      }
    ]
  },
  STATUS_DATE: {
    WEEKDAY: 1,
    SATURDAY: 2,
    SUNDAY: 3,
    HOLIDAY: 4
  },

  // 操作種類 operation_type
  OPE_TYPE: {
    DOWNLOAD: 0, //ダウンロード
    CREATE: 1, //登録
    UPDATE: 2, //編集ド
    SEARCH: 3, //検索
    VIEW: 4, //閲覧
    DELETE: 5, //削除
    HARD_DELETE: 6, //完全削除
    OTHER: 7 //その他
  },

  SHOOTING_DATE_BLACKBOARD_TYPE: [
    101, //shootingYear
    102, //shootingMonth
    103, //shootingDay
    104, //shootingYearMonth
    105, //shootingMonthDay
    106 //shootingYearMonthDay
  ],

  BLACKBOARD_ITEM_DATA_TYPE: {
    TEXT: 1,
    NUMBER: 2,
    OPTION: 3,
    FILE: 900
  },

  BLACKBOARD_FILE_ITEM_CODE: [10018, 90001],

  BLACKBOARD_TYPE_ENUM: {
    NONE: 0,
    CONSTRUCTION: 1,
    WORK_TYPE: 2,
    POINT: 3,
    BUILDER: 4,
    DESIGN_SIZE: 5,
    REAL_SIZE: 6,
    SUPERVISOR: 7,
    CONTRACTOR: 8,
    RIVER_NAME: 9,
    RAILROAD_NAME: 10,
    PLACE_NAME: 11,
    WEATHER: 12,
    PROCESS: 13,
    REMARK: 14,

    SHOOTING_YEAR: 101,
    SHOOTING_MONTH: 102,
    SHOOTING_DAY: 103,
    SHOOTING_YEAR_MONTH: 104,
    SHOOTING_MONTH_DAY: 105,
    SHOOTING_YEAR_MONTH_DAY: 106,

    SLUMP: 201,
    AIR_AMOUNT: 202,
    CONCRETE_TEMPERATURE: 203,
    OUTER_TEMPERATURE: 204,
    FLOW: 205,
    CHLORIDE: 206,

    DRAWING: 900
  }
});
